export const WEATHER_APP_URL = "https://api.weatherapi.com/v1";
export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;
